module.exports = __webpack_public_path__ + "img/WFH_Logo_big.af19b16c.png";